var _rect, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCcJcbGiant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 40,
    viewBox: "0 0 59 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57.3333,
    height: 39,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1971 20.4789C38.0533 20.4976 38.9143 20.4411 39.767 20.5083C40.6305 20.6694 40.8386 21.9767 40.0714 22.4048C39.548 22.6869 38.9261 22.5099 38.3586 22.5596H37.1971V20.4789V20.4789ZM40.262 18.1239C40.4522 18.7953 39.805 19.3981 39.1584 19.3056H37.1971C37.2109 18.6725 37.1702 17.9853 37.2171 17.3855C38.0027 17.4076 38.7956 17.3404 39.5768 17.4207C39.9124 17.505 40.1933 17.7809 40.262 18.1239V18.1239ZM44.9819 8.16753C45.0184 9.4497 44.9872 10.7996 44.9977 12.1078C44.9953 17.4264 45.0028 22.7448 44.9935 28.0637C44.9591 30.0569 43.1926 31.7889 41.2131 31.8287C39.2317 31.8368 37.25 31.83 35.2684 31.8322V23.7916C37.4275 23.7805 39.5877 23.8142 41.7459 23.7747C42.7471 23.7119 43.8438 23.0513 43.8904 21.9495C44.0083 20.8429 42.965 20.0775 41.9745 19.9567C41.5938 19.9468 41.6049 19.8457 41.9745 19.8016C42.9192 19.5974 43.6611 18.6196 43.3831 17.6404C43.1463 16.6105 42.0079 16.2118 41.0611 16.2138C39.1305 16.2007 37.1995 16.212 35.2688 16.2082C35.2813 14.7071 35.2428 13.2044 35.2895 11.7044C35.4425 9.74714 37.2535 8.13302 39.2051 8.16804C41.131 8.16775 43.0565 8.16775 44.9819 8.16767V8.16753Z",
    fill: "url(#paint0_linear_1909_22054)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4508 11.9073C13.5001 9.91716 15.2741 8.19937 17.251 8.17029C19.2251 8.1642 21.1995 8.16941 23.1735 8.16765C23.1681 14.8261 23.1842 21.4853 23.1654 28.1434C23.0893 30.1094 21.3346 31.7944 19.3793 31.8292C17.4015 31.8364 15.4234 31.8302 13.4456 31.8322V23.5206C15.3667 23.9744 17.3814 24.1676 19.3413 23.8666C20.5128 23.6781 21.7946 23.1028 22.1913 21.8873C22.4832 20.8477 22.3188 19.7535 22.3623 18.6864V16.2083H18.9704C18.9552 17.8473 19.0017 19.4891 18.9459 21.1261C18.8545 22.1322 17.858 22.7715 16.9091 22.7374C15.7322 22.7498 13.4 21.8845 13.4 21.8845C13.3941 18.8137 13.4341 14.9681 13.4508 11.9076V11.9073Z",
    fill: "url(#paint1_linear_1909_22054)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4385 17.2077C24.2599 17.2456 24.4026 16.5996 24.3569 16.3545C24.3691 14.805 24.3315 13.2538 24.3776 11.7054C24.5302 9.73985 26.3551 8.1217 28.3146 8.16771H34.0853C34.0799 14.8262 34.0959 21.4854 34.0772 28.1435C34.0011 30.1094 32.2462 31.7944 30.2908 31.8293C28.3129 31.8367 26.3348 31.8304 24.3568 31.8323V22.7258C25.7077 23.8342 27.5437 24.0067 29.2267 24.0097C30.4955 24.0093 31.7568 23.8137 32.9889 23.5211V21.8527C31.6004 22.5448 29.9681 22.9843 28.4289 22.5867C27.3552 22.3195 26.5757 21.2818 26.5931 20.1737C26.4687 19.0213 27.1442 17.8047 28.2766 17.4622C29.6826 17.022 31.2149 17.3587 32.5328 17.9309C32.8152 18.0787 33.1018 18.2621 32.9889 17.7902V16.4788C30.7847 15.9544 28.439 15.7615 26.2246 16.3319C25.5836 16.5128 24.9591 16.787 24.4385 17.2079V17.2077Z",
    fill: "url(#paint2_linear_1909_22054)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1909_22054",
    x1: 35.2019,
    y1: 19.4939,
    x2: 44.9363,
    y2: 19.4939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B03A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1909_22054",
    x1: 13.2386,
    y1: 20.2265,
    x2: 23.014,
    y2: 20.2265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1909_22054",
    x1: 24.3426,
    y1: 19.7233,
    x2: 34.0835,
    y2: 19.7233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30138"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcJcbGiant);
export default __webpack_public_path__ + "static/media/cc_jcb_giant.85ce41cd304ded61249f1c93a9cd5cc7.svg";
export { ForwardRef as ReactComponent };